import { NumberInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { CalculationFormSchema } from "@msuite/utils/schemas";
import { calculateMeasurementForUnit } from "@msuite/utils/services";
import { useFormContext, useWatch } from "react-hook-form";
import type { CalculationFormItemPositionFieldsSharedProps } from "./calculation-form-item-position-fields-shared";
import { Fragment } from "react";
import { CalculationFormItemPositionFieldsMeasurable } from "./calculation-form-item-position-fields-measurable";
import { CalculationFormItemPositionFieldsPiece } from "./calculation-form-item-position-fields-piece";
import { CalculationFormItemPositionFieldsResult } from "./calculation-form-item-position-fields-result";

export function CalculationFormItemPositionFieldsMeters({
	index,
	positionIndex,
}: CalculationFormItemPositionFieldsSharedProps) {
	/** Context */
	const methods = useFormContext<CalculationFormSchema>();
	const [quantity, meters, manualMeasurement] = useWatch({
		control: methods.control,
		name: [
			`services.${index}.positions.${positionIndex}.quantity`,
			`services.${index}.positions.${positionIndex}.meters`,
			`services.${index}.positions.${positionIndex}.manualMeasurement`,
		],
	});

	/** Hooks */
	const { t } = useTranslation();

	/** Computed */
	const result = calculateMeasurementForUnit("meters", { quantity, meters, manualMeasurement });

	/** Render */
	return (
		<Fragment>
			<CalculationFormItemPositionFieldsPiece
				index={index}
				positionIndex={positionIndex}
				step={0.5}
			/>
			<CalculationFormItemPositionFieldsMeasurable
				index={index}
				positionIndex={positionIndex}
				measurementKeys={["meters"]}
				variant="meters"
			>
				<NumberInput
					isRequired
					label={t("calculations.meters")}
					control={methods.control}
					name={`services.${index}.positions.${positionIndex}.meters`}
					min={0}
					step={0.01}
					variant="meters"
					errorVariant="tooltip"
				/>
			</CalculationFormItemPositionFieldsMeasurable>
			<CalculationFormItemPositionFieldsResult
				value={result}
				variant="meters"
			/>
		</Fragment>
	);
}
